import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { Controls } from './controls/Controls';
import Modal from './Modal';

export default function SiteSchematicModal({ isOpen, handleClose, onSubmit }) {
  const [jsonText, setJsonText] = useState('');
  const [error, setError] = useState('');

  const validateJson = (text) => {
    try {
      const parsed = JSON.parse(text);
      if (!parsed.site || !parsed.customer) {
        return 'JSON must have both "site" and "customer" keys';
      }

      if (!parsed.site.name || typeof parsed.site.name !== 'string') {
        return 'Site must have a valid name';
      }

      if (!Array.isArray(parsed.site.settings)) {
        return 'Site must have a settings array';
      }

      if (!parsed.customer.name || typeof parsed.customer.name !== 'string') {
        return 'Customer must have a valid name';
      }

      if (!Array.isArray(parsed.customer.settings)) {
        return 'Customer must have a settings array';
      }

      const validateSettings = (settings) => settings.every((setting) => setting.name
        && setting.value !== undefined
        && setting.category);

      if (!validateSettings(parsed.site.settings)) {
        return 'Each site setting must have name, value, and category';
      }

      if (!validateSettings(parsed.customer.settings)) {
        return 'Each customer setting must have name, value, and category';
      }

      return null;
    } catch (e) {
      return 'Invalid JSON format';
    }
  };

  const handleTextChange = (e) => {
    const text = e.target.value;
    setJsonText(text);
    setError(validateJson(text));
  };

  const handleSubmit = () => {
    const validationError = validateJson(jsonText);
    if (validationError) {
      setError(validationError);
      return;
    }

    const parsed = JSON.parse(jsonText);
    onSubmit(parsed);
    handleClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      handleClose={handleClose}
      title="Provide Site Schematic"
    >
      <div style={{ padding: '20px' }}>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Paste the site schematic below
        </Typography>
        <Controls.Input
          multiline
          rows={10}
          fullWidth
          value={jsonText}
          onChange={handleTextChange}
          error={!!error}
          helperText={error}
          sx={{ mb: 3 }}
        />
        <div style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '10px',
        }}
        >
          <Controls.Button
            text="Cancel"
            variant="outlined"
            onClick={handleClose}
          />
          <Controls.Button
            text="Confirm"
            variant="contained"
            onClick={handleSubmit}
            disabled={!!error || !jsonText.trim()}
          />
        </div>
      </div>
    </Modal>
  );
}

SiteSchematicModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};
